// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import xProductPartNumbersStyles from "@steiner/App/SharedStyles/ProductPartNumbersStyles";
import { productAttributesStyles } from "@steiner/Overrides/Components/ProductAttributes";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productAttributesStyles.container = {
    gap: 0,
    offsetCss: css`
        margin: 0;
    `,
};

productAttributesStyles.smallHeadingAndTextStyle = {
    heading: {
        size: 12,
        weight: fontConfig.weight.regular,
        transform: "capitalize",
        color: "text",
        css: css`
            font-weight: 400;
            letter-spacing: 0;
            line-height: 15px;
            margin-right: 4px;
            flex-shrink: 0;
            display: inline-block;
            &:after {
                content: ":";
            }
        `,
    },
    text: {
        size: 12,
        weight: fontConfig.weight.semiBold,
        color: "text",
        css: css`
            letter-spacing: 0;
            line-height: 15px;
            ${wrapInContainerStyles}
        `,
    },
    wrapper: {
        css: css`
            flex-direction: row;
            gap: 4px;
            ${xScreen("lte", "xs")} {
                flex-wrap: wrap;
            }
        `,
    },
};
